module.exports = __webpack_public_path__ + "img/winner9.b3783706.jpg";